<div class="info bold mb-5 mt-5 gap-2" [class.dark]="dark">
    <div class="font-semibold text-sm tracking-wider leading-none">
        Made with 💝
    </div>
    <div class="text-xs  tracking-wider leading-none">
        Version ##version-tag##
    </div>
</div>
